import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20theater%20interior%20with%20velvet%20red%20curtains%20and%20soft%20golden%20stage%20lighting%2C%20elegant%20movie%20palace%20design%2C%20warm%20amber%20and%20crimson%20tones%2C%20luxurious%20vintage%20cinema%20atmosphere%2C%20rich%20textures%2C%20grand%20scale%2C%20soft%20spotlight%20effects&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
        alt="红桃影院 - 高清影视在线观看平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-6 backdrop-blur-sm whitespace-nowrap">
          海量高清影视 · 免费在线观看
        </span>
        <h1 className="font-heading text-2xl md:text-5xl font-bold text-background-50 mb-4 max-w-3xl leading-tight">
          红桃影院 - 您的高清影视<span className="text-accent-400">在线观看</span>首选平台
        </h1>
        <p className="text-background-200 text-sm md:text-lg mb-8 max-w-2xl leading-relaxed">
          汇聚全球热门电影、电视剧、动漫、综艺，支持多端流畅播放，无广告打扰，随时随地畅享优质影视娱乐体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/movie"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-background-50/15 text-background-50 font-medium hover:bg-background-50/25 backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-6 md:gap-10">
          <div className="text-center">
            <p className="text-background-50 font-heading text-xl md:text-2xl font-bold">10万+</p>
            <p className="text-background-300 text-xs md:text-sm">影视资源</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-background-50 font-heading text-xl md:text-2xl font-bold">5000万+</p>
            <p className="text-background-300 text-xs md:text-sm">月活用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-background-50 font-heading text-xl md:text-2xl font-bold">4K</p>
            <p className="text-background-300 text-xs md:text-sm">超清画质</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center">
          <div className="w-1 h-3 rounded-full bg-background-50/50 mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}